import * as React from "react";

import { useIsWide } from "./useIsWide";

const LayoutContext = React.createContext<boolean | null>(null);

interface LayoutProviderProps {
  targetRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ targetRef, children }) => {
  const isWide = useIsWide(targetRef);

  return <LayoutContext.Provider value={isWide}>{children}</LayoutContext.Provider>;
};

export function useIsWideLayout(): boolean {
  const isWide = React.useContext(LayoutContext);
  if (isWide === null) {
    throw new Error("useIsWideLayout must be used within a LayoutProvider");
  }
  return isWide;
}
